import React, { useEffect, useState } from 'react';
import { getCookie } from '../../../utils/cookies';
import useComponentVisible from '../UserDropdown/useComponentVisible';
import DefaultCompanyLogo from "../../../assets/img/Logo-Black-100px.png";
import tickIcon from "../../../assets/img/blue-check.png";
import MenuIcon from "../../../assets/img/new/Menu.png";
import DefaultProviderLogo from "../../../assets/img/default_provider.png";
import DefaultAgencyLogo from "../../../assets/img/default_agency.png";
import CareHiresLogo from "../../../assets/img/Logo-Color-100px.webp";
import BuildingPlaceholder from "../../../assets/img/building-placeholder.png";
import { Apps } from '../../../utils/enum';
import { getUserDataByUID } from '../../../services/auth.service';
import styles from "./SwitchDropdown.module.css";

const APP_SWITCH_TAG_NAMES = {
  LAUNCHING_SOON: 'Launching Soon',
  CONTACT_SALES: 'Contact Sales',
  TRY_NOW: 'Try Now'
};

const SwitchDropdown: React.FC = () => {
  const chUserDataCookie = localStorage.getItem("ch_user_data");
  const userData = JSON.parse(chUserDataCookie as string);
  const userApps = userData?.apps?.map((app: any) => app?.appId?.appId);
  const userCompanies = JSON.parse(localStorage.getItem("companies") as string);
  const accessToken = getCookie("firebase_token") as string;
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const [currentCompany, setCurrentCompany] = useState<any>(null);
  const [services, setServices] = useState([
    {
      key: '1',
      title: "Care Hires",
      subtitle: "Frontline staff management system",
      link: import.meta.env.VITE_SCM_DASHBOARD_URL,
      svg: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="12" fill="#3A68FA"/>
        <path d="M30.5703 14.3203L28.5078 16.375L28.9297 16.7969C29.1621 17.0284 29.3466 17.3036 29.4724 17.6066C29.5982 17.9096 29.663 18.2344 29.663 18.5625C29.663 18.8906 29.5982 19.2154 29.4724 19.5184C29.3466 19.8214 29.1621 20.0966 28.9297 20.3281L26.9453 22.3125L27.1328 22.4922C27.2502 22.6107 27.316 22.7707 27.316 22.9375C27.316 23.1043 27.2502 23.2643 27.1328 23.3828C27.0134 23.4983 26.8537 23.5629 26.6875 23.5629C26.5213 23.5629 26.3617 23.4983 26.2422 23.3828L25.6172 22.7578L21.2422 18.3828L20.6172 17.7578C20.5175 17.6364 20.4666 17.4822 20.4743 17.3253C20.482 17.1684 20.5478 17.02 20.6589 16.9089C20.77 16.7978 20.9184 16.732 21.0753 16.7243C21.2322 16.7166 21.3864 16.7675 21.5078 16.8672L21.6875 17.0547L23.6719 15.0703C23.9034 14.8379 24.1786 14.6534 24.4816 14.5276C24.7846 14.4018 25.1094 14.337 25.4375 14.337C25.7656 14.337 26.0904 14.4018 26.3934 14.5276C26.6964 14.6534 26.9716 14.8379 27.2031 15.0703L27.625 15.4922L29.6797 13.4297C29.8011 13.33 29.9553 13.2791 30.1122 13.2868C30.2691 13.2945 30.4175 13.3603 30.5286 13.4714C30.6397 13.5825 30.7055 13.7309 30.7132 13.8878C30.7209 14.0447 30.67 14.1989 30.5703 14.3203ZM22.8047 22.8047L21.375 24.2422L19.7578 22.625L21.1953 21.1953C21.295 21.0739 21.3459 20.9197 21.3382 20.7628C21.3305 20.6059 21.2647 20.4575 21.1536 20.3464C21.0425 20.2353 20.8941 20.1695 20.7372 20.1618C20.5803 20.1541 20.4261 20.205 20.3047 20.3047L18.875 21.7422L18.3828 21.2422L17.7578 20.6172C17.6364 20.5175 17.4822 20.4666 17.3253 20.4743C17.1684 20.482 17.02 20.5478 16.9089 20.6589C16.7978 20.77 16.732 20.9184 16.7243 21.0753C16.7166 21.2322 16.7675 21.3864 16.8672 21.5078L17.0547 21.6875L15.0703 23.6719C14.8379 23.9034 14.6535 24.1786 14.5276 24.4816C14.4018 24.7846 14.337 25.1094 14.337 25.4375C14.337 25.7656 14.4018 26.0904 14.5276 26.3934C14.6535 26.6964 14.8379 26.9716 15.0703 27.2031L15.4922 27.625L13.4297 29.6797C13.3123 29.7982 13.2465 29.9582 13.2465 30.125C13.2465 30.2918 13.3123 30.4518 13.4297 30.5703C13.5492 30.6858 13.7088 30.7504 13.875 30.7504C14.0412 30.7504 14.2009 30.6858 14.3203 30.5703L16.375 28.5078L16.7969 28.9297C17.0284 29.1621 17.3036 29.3466 17.6066 29.4724C17.9096 29.5982 18.2344 29.663 18.5625 29.663C18.8906 29.663 19.2154 29.5982 19.5184 29.4724C19.8214 29.3466 20.0966 29.1621 20.3281 28.9297L22.3125 26.9453L22.4922 27.1328C22.6117 27.2483 22.7713 27.3129 22.9375 27.3129C23.1037 27.3129 23.2634 27.2483 23.3828 27.1328C23.5002 27.0143 23.566 26.8543 23.566 26.6875C23.566 26.5207 23.5002 26.3607 23.3828 26.2422L22.7578 25.6172L22.2578 25.125L23.6953 23.6953C23.795 23.5739 23.8459 23.4197 23.8382 23.2628C23.8305 23.1059 23.7647 22.9575 23.6536 22.8464C23.5425 22.7353 23.3941 22.6695 23.2372 22.6618C23.0803 22.6541 22.9261 22.705 22.8047 22.8047Z" fill="white"/>
      </svg>`
    },
    {
      key: '2',
      title: "Care Academy",
      subtitle: "Care-centric learning management system",
      link: import.meta.env.VITE_CARE_ACADEMY_APP_URL,
      tagName: APP_SWITCH_TAG_NAMES.TRY_NOW,
      svg: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="12" fill="#3A68FA"/>
        <path d="M26.0625 28.375C26.4954 28.1856 26.9133 27.9636 27.3125 27.7109V30.75C27.3125 30.9158 27.2467 31.0747 27.1295 31.1919C27.0122 31.3092 26.8533 31.375 26.6875 31.375C26.5217 31.375 26.3628 31.3092 26.2456 31.1919C26.1284 31.0747 26.0625 30.9158 26.0625 30.75V28.375ZM21.4453 19.2031C21.3696 19.3508 21.3542 19.5221 21.4023 19.681C21.4504 19.8398 21.5582 19.9738 21.7031 20.0547L25.3594 22L26.6875 21.2891L22.2969 18.9453C22.1492 18.8696 21.9779 18.8542 21.819 18.9023C21.6602 18.9504 21.5262 19.0582 21.4453 19.2031ZM31.6719 18.9453L22.2969 13.9453C22.2047 13.8992 22.1031 13.8753 22 13.8753C21.897 13.8753 21.7953 13.8992 21.7031 13.9453L12.3281 18.9453C12.2287 18.9999 12.1459 19.0802 12.0881 19.1777C12.0304 19.2753 11.9999 19.3866 11.9999 19.5C11.9999 19.6134 12.0304 19.7247 12.0881 19.8223C12.1459 19.9198 12.2287 20.0001 12.3281 20.0547L14.1875 21.0391V24.9297C14.1863 25.1979 14.2743 25.459 14.4375 25.6719C15.0547 26.5 17.4297 29.1875 22 29.1875C23.3964 29.1992 24.78 28.9198 26.0625 28.3672V22.375L25.3594 22L22 23.7891L15.1094 20.1172L13.9531 19.5L22 15.2109L30.0469 19.5L28.8906 20.1172L26.6875 21.2891L26.9844 21.4453C27.0901 21.5063 27.1766 21.5956 27.2344 21.7031C27.2863 21.7934 27.3133 21.8959 27.3125 22V27.7109C28.1758 27.1678 28.9373 26.4777 29.5625 25.6719C29.7257 25.459 29.8137 25.1979 29.8125 24.9297V21.0391L31.6719 20.0547C31.7713 20.0001 31.8542 19.9198 31.9119 19.8223C31.9696 19.7247 32.0001 19.6134 32.0001 19.5C32.0001 19.3866 31.9696 19.2753 31.9119 19.1777C31.8542 19.0802 31.7713 18.9999 31.6719 18.9453Z" fill="white"/>
      </svg>`
    },
    {
      key: '3',
      title: "Care Rota",
      subtitle: "Rostering solution for permanent staff",
      link: import.meta.env.VITE_ROTA_APP_URL,
      svg: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="12" fill="#3A68FA"/>
        <path d="M28.25 14.5H26.375V13.875C26.375 13.7092 26.3092 13.5503 26.1919 13.4331C26.0747 13.3158 25.9158 13.25 25.75 13.25C25.5842 13.25 25.4253 13.3158 25.3081 13.4331C25.1908 13.5503 25.125 13.7092 25.125 13.875V14.5H18.875V13.875C18.875 13.7092 18.8092 13.5503 18.6919 13.4331C18.5747 13.3158 18.4158 13.25 18.25 13.25C18.0842 13.25 17.9253 13.3158 17.8081 13.4331C17.6908 13.5503 17.625 13.7092 17.625 13.875V14.5H15.75C15.4185 14.5 15.1005 14.6317 14.8661 14.8661C14.6317 15.1005 14.5 15.4185 14.5 15.75V28.25C14.5 28.5815 14.6317 28.8995 14.8661 29.1339C15.1005 29.3683 15.4185 29.5 15.75 29.5H28.25C28.5815 29.5 28.8995 29.3683 29.1339 29.1339C29.3683 28.8995 29.5 28.5815 29.5 28.25V15.75C29.5 15.4185 29.3683 15.1005 29.1339 14.8661C28.8995 14.6317 28.5815 14.5 28.25 14.5ZM25.2422 22.4531L21.5938 25.8906C21.537 25.9462 21.4698 25.99 21.3961 26.0195C21.3223 26.049 21.2435 26.0636 21.1641 26.0625C21.004 26.0631 20.8499 26.0015 20.7344 25.8906L18.7578 24.0156C18.6943 23.9602 18.6427 23.8926 18.606 23.8167C18.5693 23.7409 18.5484 23.6584 18.5444 23.5742C18.5404 23.49 18.5535 23.4059 18.5828 23.327C18.6122 23.248 18.6572 23.1758 18.7152 23.1146C18.7732 23.0535 18.8429 23.0047 18.9202 22.9712C18.9975 22.9377 19.0808 22.9202 19.1651 22.9197C19.2493 22.9192 19.3328 22.9357 19.4105 22.9683C19.4882 23.0009 19.5585 23.0489 19.6172 23.1094L21.1641 24.5781L24.3828 21.5469C24.4418 21.4896 24.5117 21.4446 24.5884 21.4147C24.665 21.3848 24.7469 21.3705 24.8292 21.3727C24.9114 21.3749 24.9924 21.3935 25.0674 21.4274C25.1423 21.4614 25.2097 21.5099 25.2656 21.5703C25.3795 21.6906 25.4409 21.8511 25.4365 22.0166C25.4321 22.1821 25.3622 22.3391 25.2422 22.4531ZM28.25 18.25H15.75V15.75H17.625V16.375C17.625 16.5408 17.6908 16.6997 17.8081 16.8169C17.9253 16.9342 18.0842 17 18.25 17C18.4158 17 18.5747 16.9342 18.6919 16.8169C18.8092 16.6997 18.875 16.5408 18.875 16.375V15.75H25.125V16.375C25.125 16.5408 25.1908 16.6997 25.3081 16.8169C25.4253 16.9342 25.5842 17 25.75 17C25.9158 17 26.0747 16.9342 26.1919 16.8169C26.3092 16.6997 26.375 16.5408 26.375 16.375V15.75H28.25V18.25Z" fill="white"/>
      </svg>`
    },
    {
      key: '4',
      title: "Care Hires Reporting Suite",
      subtitle: "Reporting and analytics dashboard",
      link: `${import.meta.env.VITE_SCM_DASHBOARD_URL}?redirect=${encodeURIComponent("/reports")}`,
      tagName: APP_SWITCH_TAG_NAMES.CONTACT_SALES,
      svg: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="12" fill="#3A68FA"/>
        <path d="M29.8125 27.625H29.1875V15.125C29.1875 14.9592 29.1217 14.8003 29.0044 14.6831C28.8872 14.5658 28.7283 14.5 28.5625 14.5H24.1875C24.0217 14.5 23.8628 14.5658 23.7456 14.6831C23.6283 14.8003 23.5625 14.9592 23.5625 15.125V18.25H19.8125C19.6467 18.25 19.4878 18.3158 19.3706 18.4331C19.2533 18.5503 19.1875 18.7092 19.1875 18.875V22H15.4375C15.2717 22 15.1128 22.0658 14.9956 22.1831C14.8783 22.3003 14.8125 22.4592 14.8125 22.625V27.625H14.1875C14.0217 27.625 13.8628 27.6908 13.7456 27.8081C13.6283 27.9253 13.5625 28.0842 13.5625 28.25C13.5625 28.4158 13.6283 28.5747 13.7456 28.6919C13.8628 28.8092 14.0217 28.875 14.1875 28.875H29.8125C29.9783 28.875 30.1372 28.8092 30.2544 28.6919C30.3717 28.5747 30.4375 28.4158 30.4375 28.25C30.4375 28.0842 30.3717 27.9253 30.2544 27.8081C30.1372 27.6908 29.9783 27.625 29.8125 27.625ZM20.4375 19.5H23.5625V27.625H20.4375V19.5ZM16.0625 23.25H19.1875V27.625H16.0625V23.25Z" fill="white"/>
      </svg>`
    },
    {
      key: '5',
      title: "Marketplace",
      subtitle: "Agency marketplace for Care contracts",
      link: import.meta.env.VITE_B4C_APP_URL,
      license: "",
      svg: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="12" fill="#3A68FA"/>
        <path d="M26.4484 21.07C26.454 20.957 26.4652 20.8464 26.4652 20.7326C26.4652 17.02 23.4451 14 19.7326 14C16.0202 14 13 17.0202 13 20.7326V27.1447C13 27.2746 13.0777 27.3916 13.198 27.4413C13.238 27.4581 13.2797 27.4653 13.3206 27.4653C13.404 27.4653 13.4857 27.4325 13.5474 27.3716L15.2042 25.7148C16.4457 26.8458 18.0415 27.4653 19.7327 27.4653C20.5751 27.4653 21.379 27.3026 22.1235 27.0189C22.0313 26.6478 21.9768 26.2614 21.9768 25.8623C21.9768 23.3247 23.9541 21.2447 26.4484 21.07ZM19.2516 20.412H20.2135C22.1195 20.4721 22.1203 23.2374 20.2135 23.2974H20.0532V23.9386C20.0468 24.3578 19.4192 24.3618 19.412 23.9386V23.2974H18.1295C17.7087 23.2893 17.7071 22.6642 18.1295 22.6561H20.2134C20.655 22.6561 21.0149 22.2963 21.0149 21.8546C21.0149 21.413 20.655 21.0531 20.2134 21.0531H19.2516C17.3456 20.993 17.3448 18.2277 19.2516 18.1678H19.4119V17.5266C19.4119 17.3494 19.5554 17.206 19.7325 17.206C19.9096 17.206 20.0531 17.3494 20.0531 17.5266V18.1678H21.3355C21.5127 18.1678 21.6561 18.3113 21.6561 18.4884C21.6561 18.6655 21.5127 18.809 21.3355 18.809H19.2516C18.1945 18.8371 18.1945 20.384 19.2516 20.412Z" fill="white"/>
        <path d="M16.3338 16.2868H23.8573L21.5062 25.221L16.3338 23.8103V16.2868Z" fill="white"/>
        <path d="M22.1646 22.9731C22.1624 23.1229 22.0373 23.244 21.8824 23.2461H17.7446C17.6318 23.2474 17.5295 23.1826 17.4851 23.0823C17.442 22.9841 17.4611 22.8708 17.5341 22.791C17.9932 22.313 18.2877 21.7092 18.3765 21.0627H17.7446C17.5891 21.0627 17.4625 20.9403 17.4625 20.7898C17.4625 20.639 17.5891 20.5169 17.7446 20.5169H18.3956C18.3956 20.4405 18.3956 20.3603 18.373 20.2839L18.2189 19.1922H18.2185C18.2168 19.1803 18.2168 19.168 18.2185 19.1557C18.245 18.7225 18.4467 18.3165 18.7806 18.0261C19.1146 17.7358 19.5533 17.5847 20.0014 17.6055C20.45 17.5837 20.889 17.7338 21.2237 18.0234C21.5583 18.3131 21.7611 18.7187 21.7882 19.1523V19.3341C21.7882 19.4849 21.662 19.607 21.5061 19.607C21.3503 19.607 21.224 19.4849 21.224 19.3341V19.1523C21.2 18.8623 21.0576 18.5935 20.828 18.4059C20.5984 18.2179 20.3012 18.1265 20.0014 18.1514C19.3843 18.0988 18.8388 18.5372 18.7792 19.1339L18.9333 20.2255C18.9333 20.3275 18.9559 20.433 18.9633 20.535H20.3777C20.5336 20.535 20.6598 20.6571 20.6598 20.8079C20.6598 20.9587 20.5336 21.0808 20.3777 21.0808H18.9407C18.8663 21.6614 18.6498 22.2165 18.3088 22.7002H21.8824C22.0372 22.7019 22.1624 22.823 22.1646 22.9731Z" fill="#3A68FA"/>
        <path d="M26.7862 21.6944C24.4883 21.6944 22.6184 23.5644 22.6184 25.8622C22.6184 28.16 24.4883 30.03 26.7862 30.03C27.7921 30.03 28.7435 29.6765 29.4977 29.0273L30.4067 29.9362C30.4684 29.9979 30.5501 30.03 30.6335 30.03C30.6752 30.03 30.7168 30.022 30.7561 30.0059C30.8755 29.9562 30.9541 29.8392 30.9541 29.7094V25.8621C30.9541 23.5642 29.084 21.6944 26.7862 21.6944ZM27.9748 25.4479C27.8498 25.573 27.647 25.573 27.5212 25.4479L27.1068 25.0336V27.4654C27.1004 27.8854 26.4728 27.8878 26.4656 27.4654V25.0336L26.0512 25.4479C25.7539 25.7429 25.3026 25.2924 25.5976 24.9943L26.5594 24.0325C26.6788 23.909 26.8936 23.909 27.013 24.0325L27.9749 24.9943C28.0999 25.1193 28.0999 25.3221 27.9748 25.4479Z" fill="white"/>
      </svg>`
    },
    {
      key: '6',
      title: "Care Hires Admin",
      subtitle: "Administrator system controls",
      link: '',
      tagName: APP_SWITCH_TAG_NAMES.LAUNCHING_SOON,
      svg: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="12" fill="#3A68FA"/>
        <path d="M30.1172 28.5625C28.951 26.5535 27.0843 25.0457 24.875 24.3281C25.934 23.6984 26.7569 22.7384 27.2174 21.5956C27.6779 20.4529 27.7504 19.1905 27.4239 18.0025C27.0973 16.8145 26.3898 15.7666 25.4099 15.0197C24.43 14.2729 23.2321 13.8683 22 13.8683C20.768 13.8683 19.57 14.2729 18.5901 15.0197C17.6103 15.7666 16.9027 16.8145 16.5762 18.0025C16.2496 19.1905 16.3222 20.4529 16.7826 21.5956C17.2431 22.7384 18.066 23.6984 19.125 24.3281C16.9157 25.0457 15.049 26.5535 13.8828 28.5625C13.8256 28.6567 13.7953 28.7648 13.7953 28.875C13.7953 28.9852 13.8256 29.0933 13.8828 29.1875C13.9362 29.2833 14.0145 29.3629 14.1094 29.4179C14.2043 29.4729 14.3122 29.5012 14.4219 29.5H29.5781C29.6878 29.5012 29.7958 29.4729 29.8906 29.4179C29.9855 29.3629 30.0638 29.2833 30.1172 29.1875C30.1745 29.0933 30.2047 28.9852 30.2047 28.875C30.2047 28.7648 30.1745 28.6567 30.1172 28.5625Z" fill="white"/>
      </svg>`
    }
  ]);

  useEffect(() => {
    if (userData) {
      if (userData?.provider) {
        setCurrentCompany({ 
          name: userData.provider.companyName, 
          id: userData.provider._id, 
          image: DefaultProviderLogo, 
          parentOrganisation: userData.provider?.parentCompany?.name, 
          isAgency: false 
        });
      } else if (userData?.agency) {
        setCurrentCompany({ 
          name: userData.agency?.businessName, 
          id: userData.agency?._id, 
          image: DefaultAgencyLogo, 
          parentOrganisation: userData.agency?.parentCompany?.name, 
          isAgency: true 
        });
      } else {
        setCurrentCompany({ 
          name: "Care Hires Limited", 
          id: userData._id, 
          image: CareHiresLogo, 
          isAgency: false 
        });
      }

      const filteredServices = services.filter(service => {
        if (service.title === 'Care Academy') {
          if (userData.userGroup === 'Provider') return false;
        }
        if (service.title === 'Care Rota') {
          if (userData.userGroup === 'Agency') return false;
        }
        if (service.title === 'Marketplace') {
          if (userData.userGroup === 'Provider') return false;
        }
        return true;
      });

      const updatedServices = filteredServices.map(service => {
        const updatedService = { ...service };
        const logoColorCode = userData.userGroup === 'Agency' ? '#FFAB40' : '#3A68FA';
        
        if (updatedService.svg) {
          updatedService.svg = updatedService.svg.replace(/#3A68FA/g, logoColorCode);
        }

        if (updatedService.title === 'Care Academy') {
          if (userData.userGroup === 'Agency') {
            const hasLicenses = userData.agency?.noOfLicensesIssued > 0;
            const hasApp = userApps.includes(Apps.ACADEMY);
            if (hasLicenses) {
              if (hasApp) {
                updatedService.link = import.meta.env.VITE_CARE_ACADEMY_APP_URL;
                updatedService.tagName = undefined;
              } else {
                updatedService.tagName = APP_SWITCH_TAG_NAMES.CONTACT_SALES;
                updatedService.link = import.meta.env.VITE_CARE_ACADEMY_APP_URL;
              }
            } else {
              updatedService.tagName = APP_SWITCH_TAG_NAMES.TRY_NOW;
              updatedService.link = import.meta.env.VITE_CARE_ACADEMY_APP_URL;
            }
          }
        } else if (updatedService.title === 'Care Rota') {
          if (userData.userGroup === 'Provider') {
            if (userApps.includes(Apps.ROTA)) {
              updatedService.link = import.meta.env.VITE_ROTA_APP_URL;
            } else {
              updatedService.link = 'try-now-landing-page';
              updatedService.tagName = APP_SWITCH_TAG_NAMES.CONTACT_SALES;
            }
          }
        } else if (updatedService.title === 'Care Hires Reporting Suite') {
          if (userData.userGroup === 'Provider' || userData.userGroup === 'Agency') {
            updatedService.tagName = APP_SWITCH_TAG_NAMES.CONTACT_SALES;
            updatedService.link = 'try-now-landing-page';
          }
        } else if (updatedService.title === 'Marketplace') {
          if (userData.userGroup === 'Agency') {
            if (userApps.includes(Apps.B4C)) {
              updatedService.link = import.meta.env.VITE_B4C_APP_URL;
              updatedService.license = undefined;
            } else {
              updatedService.tagName = APP_SWITCH_TAG_NAMES.CONTACT_SALES;
              updatedService.link = 'try-now-landing-page';
            }
          }
        }

        return updatedService;
      });

      setServices(updatedServices);
    }
  }, []);

  const toggleDropdown = () => {
    setIsComponentVisible(!isComponentVisible);
  };

  const getTagClassName = (tagName: string): string => {
    switch (tagName) {
      case APP_SWITCH_TAG_NAMES.LAUNCHING_SOON:
        return styles.launchingSoon;
      case APP_SWITCH_TAG_NAMES.CONTACT_SALES:
        return styles.contactSales;
      case APP_SWITCH_TAG_NAMES.TRY_NOW:
        return styles.tryNow;
      default:
        return '';
    }
  };

  const gotoLink = (url: string, platform: string) => {
    if (url.trim() !== '') {
      if (url === 'try-now-landing-page') {
        window.location.href = `${url}/${platform}`;
      } else if (url.startsWith('/')) {
      } else {
        window.open(url, '_blank');
      }
    }
  };

  const selectService = (service: any) => {
    toggleDropdown();
    gotoLink(service.link, service.title);
  };

  const switchCompany = async (company: any) => {
    if (company.provider) {
      const providerUserData = await getUserDataByUID(userData.uid, accessToken, undefined, company?.provider?._id);
      localStorage.setItem("ch_user_data", JSON.stringify({...providerUserData.data, apps: company?.apps}));
      const updatedCompanies = userCompanies.map((comp: any) => ({
        ...comp,
        isSelected: comp === company
      }));
      localStorage.setItem("companies", JSON.stringify(updatedCompanies));
      window.location.reload();
    } else {
      const agencyUserData = await getUserDataByUID(userData.uid, accessToken, company?.agency?._id, undefined);
      localStorage.setItem("ch_user_data", JSON.stringify({...agencyUserData.data, apps: company?.apps}));
      const updatedCompanies = userCompanies.map((comp: any) => ({
        ...comp,
        isSelected: comp === company
      }));
      localStorage.setItem("companies", JSON.stringify(updatedCompanies));
      window.location.reload();
    }
  };

  const getCompanyImage = (company: any) => {
    return company?.image?.imageSmall ? company.image.imageSmall : BuildingPlaceholder;
  };

  return (
    <div ref={ref} className={styles.dropdown}>
      <div className="d-flex flex-column justify-content-center align-items-center my-4">
        <img src={MenuIcon} onClick={toggleDropdown} alt="Menu" />
      </div>
      
      {isComponentVisible && (
        <div className={styles.dropdownMenu}>
          <div className={styles.dropdownContent}>
            {currentCompany && (
              <div className={`${styles.currentCompany} ${currentCompany.isAgency ? styles.currentCompanyAgency : ''}`}>
                <img src={currentCompany.image} alt={currentCompany.name} />
                <div className={styles.textContainer}>
                  <p className={styles.companyName}>{currentCompany.name}</p>
                  {currentCompany.parentOrganisation && (
                    <p className={styles.parentOrganisation}>{currentCompany.parentOrganisation}</p>
                  )}
                </div>
              </div>
            )}

            {userCompanies?.length > 1 && (
              <div className={styles.companyList}>
                <p className={styles.heading}>Select the Child Organisation you want to view</p>
                <div className={styles.companies}>
                  <div className={styles.chCarousel}>
                    {userCompanies.map((company: any, index: number) => (
                      <div 
                        key={index} 
                        className={`${styles.chCarouselItem} ${company.isSelected ? styles.chCarouselItemSelected : ''}`}
                        onClick={() => switchCompany(company)}
                      >
                        {company.isSelected && !currentCompany?.isAgency && (
                          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" className={styles.tickIcon}>
                            <circle cx="5.5" cy="5.5" r="2.75" fill="white"/>
                            <path d="M5.5 1.03125C4.61617 1.03125 3.75218 1.29334 3.0173 1.78437C2.28242 2.2754 1.70964 2.97333 1.37142 3.78988C1.03319 4.60644 0.94469 5.50496 1.11712 6.37181C1.28955 7.23866 1.71515 8.03492 2.34012 8.65988C2.96508 9.28485 3.76134 9.71046 4.62819 9.88288C5.49504 10.0553 6.39356 9.96682 7.21012 9.62859C8.02668 9.29036 8.7246 8.71759 9.21563 7.9827C9.70667 7.24782 9.96875 6.38384 9.96875 5.5C9.96648 4.31551 9.49494 3.18019 8.65738 2.34263C7.81981 1.50506 6.68449 1.03352 5.5 1.03125ZM7.62696 4.71797L5.10899 7.12422C5.04389 7.18545 4.95773 7.2193 4.86836 7.21875C4.82468 7.21938 4.78131 7.21134 4.74074 7.19512C4.70018 7.17889 4.66323 7.1548 4.63203 7.12422L3.37305 5.92109C3.33813 5.89063 3.30973 5.85342 3.28956 5.81169C3.26939 5.76997 3.25786 5.7246 3.25567 5.67831C3.25348 5.63202 3.26067 5.58577 3.27681 5.54233C3.29296 5.49889 3.31772 5.45916 3.3496 5.42554C3.38149 5.39191 3.41985 5.36508 3.46237 5.34665C3.50489 5.32823 3.5507 5.31859 3.59704 5.31832C3.64338 5.31806 3.6893 5.32716 3.73203 5.34509C3.77476 5.36302 3.81343 5.3894 3.84571 5.42266L4.86836 6.39805L7.1543 4.21953C7.22114 4.16122 7.30793 4.131 7.39653 4.13519C7.48513 4.13938 7.56868 4.17766 7.62972 4.24202C7.69075 4.30639 7.72455 4.39185 7.72403 4.48055C7.72351 4.56925 7.68873 4.65432 7.62696 4.71797Z" fill="#444CF8"/>
                          </svg>
                        )}
                        {company.isSelected && currentCompany?.isAgency && (
                          <svg width="9" height="9" viewBox="0 0 9 9" fill="none" className={styles.tickIcon}>
                            <path d="M4.5 0.03125C3.61617 0.03125 2.75218 0.293338 2.0173 0.78437C1.28242 1.2754 0.709644 1.97333 0.371415 2.78988C0.0331862 3.60644 -0.0553099 4.50496 0.117118 5.37181C0.289546 6.23866 0.715153 7.03492 1.34012 7.65988C1.96508 8.28485 2.76134 8.71046 3.62819 8.88288C4.49504 9.05531 5.39356 8.96682 6.21012 8.62859C7.02668 8.29036 7.7246 7.71759 8.21563 6.9827C8.70667 6.24782 8.96875 5.38384 8.96875 4.5C8.96648 3.31551 8.49494 2.18019 7.65738 1.34263C6.81981 0.505064 5.68449 0.0335213 4.5 0.03125ZM6.62696 3.71797L4.10899 6.12422C4.04389 6.18545 3.95773 6.2193 3.86836 6.21875C3.82468 6.21938 3.78131 6.21134 3.74074 6.19512C3.70018 6.17889 3.66323 6.1548 3.63203 6.12422L2.37305 4.92109C2.33813 4.89063 2.30973 4.85342 2.28956 4.81169C2.26939 4.76997 2.25786 4.7246 2.25567 4.67831C2.25348 4.63202 2.26067 4.58577 2.27681 4.54233C2.29296 4.49889 2.31772 4.45916 2.3496 4.42554C2.38149 4.39191 2.41985 4.36508 2.46237 4.34665C2.50489 4.32823 2.5507 4.31859 2.59704 4.31832C2.64338 4.31806 2.6893 4.32716 2.73203 4.34509C2.77476 4.36302 2.81343 4.3894 2.84571 4.42266L3.86836 5.39805L6.1543 3.21953C6.22114 3.16122 6.30793 3.131 6.39653 3.13519C6.48513 3.13938 6.56868 3.17766 6.62972 3.24202C6.69075 3.30639 6.72455 3.39185 6.72403 3.48055C6.72351 3.56925 6.68873 3.65432 6.62696 3.71797Z" fill="#DE7C00"/>
                          </svg>
                        )}
                        <img 
                          src={getCompanyImage(company)} 
                          alt={company.name}
                          className={`${company.isSelected ? (currentCompany?.isAgency ? styles.selectedAgency : styles.selected) : ''}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            <div className={styles.productList}>
              {services.map((service) => {
                const tagName = service.tagName || service.license;
                const tagClassName = getTagClassName(tagName as string);
                const isSelected = service.title === 'Care Hires';
                
                return (
                  <div 
                    key={service.key}
                    className={`${styles.product} ${isSelected ? styles.productSelected : ''}`}
                    onClick={() => selectService(service)}
                  >
                    {tagName && (
                      <span className={`${styles.tag} ${tagClassName}`}>{tagName}</span>
                    )}
                    <div 
                      className={styles.svgContainer}
                      dangerouslySetInnerHTML={{ __html: service.svg || '' }}
                    />
                    <div className={styles.textContainer}>
                      <p className={styles.productName}>{service.title}</p>
                      <p className={styles.productSubtitle}>{service.subtitle}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SwitchDropdown;